import { Img } from "components"

type Props = {
  title: string
  excerpt: string
  date: string
  imageSrc: string
  imageAlt: string
}

export function FeaturedArticleCard({ title, excerpt, date, imageSrc, imageAlt }: Props) {
  return (
    <div className="border bg-card rounded-xl shadow-sm">
      <div className="p-4 sm:p-6">
        <div className="overflow-hidden rounded-lg border">
          <Img
            src={imageSrc || "/placeholder.svg"}
            alt={imageAlt}
            width={1200}
            height={675}
            className="h-auto w-full"
          />
        </div>

        <h3 className="mt-4 text-balance text-xl sm:text-2xl md:text-[26px] font-semibold text-foreground">{title}</h3>

        <p className="mt-3 text-sm leading-6 text-muted-foreground">{excerpt}</p>

        <div className="mt-4 flex items-center justify-between">
          <a href="#" className="text-sm text-primary hover:underline">
            {date}
          </a>
          <a href="#" className="text-sm font-medium text-primary hover:underline">
            Read Blog →
          </a>
        </div>
      </div>
    </div>
  )
}
